export const PHASES = ['startup', 'shutdown'];
export const phaseLabel = (phase) => phase === 'shutdown' ? 'Shutdown' : 'Startup';
export const copyRoutine = (routine) => ({ mode: routine.mode, revision: routine.revision,
  steps: (routine.steps || []).map((step) => ({ ...step })) });
export const routineChanged = (draft, saved) => Boolean(draft && saved
  && JSON.stringify({ mode: draft.mode, steps: draft.steps }) !== JSON.stringify({ mode: saved.mode, steps: saved.steps }));
export const stepKey = () => globalThis.crypto?.randomUUID?.() || `step-${Date.now()}-${Math.random().toString(36).slice(2)}`;
export function customiseRoutine(draft, screens, phase) {
  return { ...draft, mode: 'custom', steps: screens.filter((screen) => screen.configured?.[phase]).slice(0, 199)
    .map((screen) => ({ key: stepKey(), type: 'screen', areaId: screen.areaId, screenId: screen.id }))
    .concat({ key: stepKey(), type: 'remaining_screens' }) };
}
export function previewRoutine(draft, screens, phase) {
  if (!draft) return [];
  const explicit = new Set(draft.steps.filter((step) => step.type === 'screen').map((step) => Number(step.screenId)));
  const screenStep = (step) => {
    const screen = screens.find((entry) => entry.id === Number(step.screenId) && entry.areaId === Number(step.areaId));
    return { ...step, description: `${phase === 'shutdown' ? 'Stop' : 'Start'} ${screen ? `${screen.areaName} · ${screen.name}` : 'missing Screen'}`,
      status: !screen ? 'missing' : screen.configured?.[phase] ? 'configured' : 'skipped',
      reason: !screen ? 'Choose a Screen in this site.' : screen.configured?.[phase] ? null : `No ${phase} routine configured — skipped.` };
  };
  const remaining = (excluded, key) => screens.filter((screen) => !excluded.has(screen.id)).map((screen) =>
    screenStep({ key: `${key}:${screen.id}`, type: 'screen', screenId: screen.id, areaId: screen.areaId }));
  if (draft.mode === 'default') return remaining(new Set(), 'default');
  return draft.steps.flatMap((step) => step.type === 'remaining_screens' ? remaining(explicit, step.key)
    : [step.type === 'screen' ? screenStep(step) : { ...step, description: step.type === 'delay'
      ? `Wait ${step.seconds || 0} seconds` : `Assistant: ${step.query || 'Enter a phrase'}` }]);
}
export function validateDraft(draft) {
  if (!draft || !['default', 'custom'].includes(draft.mode)) return 'Choose default or custom behaviour.';
  if (draft.steps.length > 200) return 'A routine can contain at most 200 steps.';
  const screens = new Set();
  let remaining = false;
  for (const step of draft.steps) {
    if (step.type === 'screen') {
      if (!Number.isInteger(step.screenId) || step.screenId < 1 || !Number.isInteger(step.areaId) || step.areaId < 1) return 'Choose a Screen for every Screen step.';
      if (screens.has(step.screenId)) return 'List each Screen only once.';
      screens.add(step.screenId);
    } else if (step.type === 'remaining_screens') {
      if (remaining) return 'Add remaining Screens only once.';
      remaining = true;
    } else if (step.type === 'delay') {
      if (!Number.isInteger(step.seconds) || step.seconds < 1 || step.seconds > 3600) return 'Delays must be 1–3600 seconds.';
    } else if (step.type === 'assistant') {
      if (!step.query?.trim() || step.query.trim().length > 1000) return 'Enter an Assistant phrase of 1–1000 characters.';
    } else return 'Choose a supported step type.';
  }
  return '';
}
